import { GlobalStyles, Paper } from "@mui/material";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { useContext } from "react";
import { Footer } from "../../../components/Footer";
import { AppContext } from "../../../context";
import { Alert } from "../../../images/alert";

export const EwqPyamentFail = () => {
  const { theme, logo, contact } = useContext<any>(AppContext);

  return (
    <>
      <Container component="main" maxWidth="md">
        <GlobalStyles
          styles={{
            body: {
              backgroundColor: `white`,
            },
          }}
        />
        <Paper
          variant="outlined"
          elevation={2}
          sx={{
            my: 3,
            // backgroundColor: `#dcdcdc`,
            display: "flex",
            flexDirection: "column",
            height: "90vh",
            justifyContent: "space-evenly",
            // maxHeight: 700
          }}
        >
          <img src={logo} alt="" style={{ margin: "0 auto", width: "250px" }} />
          <Typography
            sx={{
              color: "primary.main",
              fontSize: "2rem",
              p: 1,
              fontWeight: "bold",
            }}
            align="center"
          >
            Ops! Nosso sistema se comportou de forma inesperada
          </Typography>
          <Box sx={{ mx: "auto" }}>
            <Alert />
          </Box>
          <Box>
            <Typography
              sx={{ color: "primary.main", fontSize: "1.5rem", p: 1 }}
              align="center"
            >
              Tente novamente mais tarde ou entre em contato conosco:{" "}
              {contact ? contact : "atendimento@briasaude.com"}
            </Typography>
          </Box>
          <Box sx={{ width: "100wv", alignItems: "center" }}>
            <Footer />
          </Box>
        </Paper>
      </Container>
    </>
  );
};
